export class SystemNoteEdit
{
    public id = null;
    public text = '';
}
